import { providers } from '../../providers';
import { wavespeed } from '../wavespeed/index';
import type { TersaSpeechModel } from '../types';

// 系数
const COST_FACTOR = 2;

export const googleModels: Record<string, TersaSpeechModel> = {
    'lyria-3-clip': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: wavespeed.speech('lyria-3-clip'),
                getCost: () => {
                    return 0.04 * COST_FACTOR;
                },
            },
        ],
        voices: [],
        precheck: ['prompt'],
        supportsInput: ['t2m'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'lyria-3-pro': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: wavespeed.speech('lyria-3-pro'),
                getCost: () => {
                    return 0.04 * COST_FACTOR;
                },
            },
        ],
        voices: [],
        precheck: ['prompt'],
        supportsInput: ['t2m'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};